<template>
  <div>
    <div id="SumClaimMDDetailed"></div>
  </div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

export default {
  name: "SumClaimMDDetailed",
  props: {
    chartData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      // mappedData: null,

      // dummyData: [
      //   { category: "Electronics", value: 150 },
      //   { category: "Automotive", value: 90 },
      //   { category: "Retail", value: 120 },
      //   { category: "Healthcare", value: 75 },
      //   { category: "Education", value: 110 },
      // ],
      chart: null,
      noDataLabel: null,
      colors: ["#ACF9FF", "#F2809F", "#80B2EF", "#F2BC80", "#80F2AC"],
      innerLabel: null,
    };
  },
  // watch: {
  //   chartData: {
  //     handler(newData) {
  //       this.updateChart(newData);
  //     },
  //     immediate: true,
  //   },
  // },
  mounted() {
    this.createChart();
    // this.updateChart();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
  methods: {
    createChart() {
      // console.log("🔵 Creating chart...", this.chart);

      this.chart = am4core.create("SumClaimMDDetailed", am4charts.PieChart);
      this.chart.innerRadius = am4core.percent(45);
      this.chart.radius = am4core.percent(55);
      this.chart.seriesContainer.dy = -60;

      this.pieSeries = this.chart.series.push(new am4charts.PieSeries());
      this.pieSeries.dataFields.value = "value";
      this.pieSeries.dataFields.category = "label";
      this.pieSeries.slices.template.propertyFields.fill = "color";

      this.pieSeries.labels.template.disabled = true;
      this.pieSeries.ticks.template.disabled = true;

      this.pieSeries.slices.template.tooltipText =
        "{category}: {value} ({value.percent.formatNumber('#.0')}%)";
      this.pieSeries.tooltip.getFillFromObject = false;
      this.pieSeries.tooltip.background.fill = am4core.color("#000");
      this.pieSeries.tooltip.label.fill = am4core.color("#fff");

      this.chart.legend = new am4charts.Legend();
      // this.chart.legend.position = "bottom";
      this.chart.legend.position = "absolute";
      this.chart.legend.x = 30;
      this.chart.legend.y = 470;
      this.chart.legend.valueLabels.template.disabled = true;
      this.chart.legend.dataFields.name = "label";
      this.chart.legend.maxWidth = am4core.percent(100);
      this.chart.legend.contentAlign = "center";
      this.chart.legend.useDefaultMarker = true;
      this.chart.legend.labels.template.maxWidth = 150;
      this.chart.legend.itemContainers.template.marginBottom = 5;
      this.chart.legend.itemContainers.template.wrap = true;
      // this.chart.legend.layout = "horizontal";
      this.chart.legend.itemContainers.template.width = am4core.percent(20);
      this.chart.legend.itemContainers.template.marginRight = 10;
      this.chart.legend.itemContainers.template.marginLeft = 10;

      // Handle legend click
      this.chart.legend.itemContainers.template.events.on("toggled", () => {
        setTimeout(() => {
          this.updateMaxValueLabel();
        }, 10);
      });

      this.innerLabel = this.chart.seriesContainer.createChild(am4core.Label);
      this.innerLabel.horizontalCenter = "middle";
      this.innerLabel.verticalCenter = "middle";
      this.innerLabel.fontSize = 20;
      this.innerLabel.textAlign = "middle";

      this.createNoDataLabel();
      this.updateChart(this.chartData);
      // this.updateChart(this.dummyData);
    },
    createNoDataLabel() {
      if (!this.chart) return;

      this.noDataLabel = this.chart.createChild(am4core.Label);
      this.noDataLabel.align = "center";
      this.noDataLabel.valign = "middle";
      // this.noDataLabel.paddingBottom = 30;
      this.noDataLabel.verticalCenter = "middle";
      this.noDataLabel.horizontalCenter = "middle";
      this.noDataLabel.role = "noDataLabel";
      this.noDataLabel.x = am4core.percent(50);
      this.noDataLabel.y = am4core.percent(50);
      this.noDataLabel.isMeasured = false;
      this.noDataLabel.html = `
        <div class="chart-no-data">
          <span>0</span>
          <span>No Data</span> 
        </div>
        `;
      this.noDataLabel.hide();

      // this.noDataLabel2 = this.chart.createChild(am4core.Label);
      // this.noDataLabel2.align = "center";
      // this.noDataLabel2.verticalCenter = "middle";
      // this.noDataLabel2.role = "noDataLabel2";
      // this.noDataLabel2.html = `
      //   <div class="donut instalment4">
      //     <div class="donut-default"></div>
      //     <div class="donut-line"></div>
      //     <div class="donut-text">
      //         <div class="zero">0</div>
      //         <div>No Data</div>
      //     </div>
      //     <div class="donut-case"></div>
      //   </div>
      //   `;
      // // this.noDataLabel2.html = `
      // //   <p style="font-weight: bold; font-size: 1.5rem;">No Data Available.</p>
      // //   <p style="margin-top: -0.5rem">Please choose another time or option</p>`;
      // this.noDataLabel2.hide();
    },
    toggleNoDataLabel(data) {
      console.log("Mapped data:", data);
      const hasData = data && data.some((item) => parseInt(item.value, 10) > 0);

      if (!hasData) {
        this.noDataLabel.show();
        this.chart.seriesContainer.hide();
        this.chart.data = [];
        this.chart.legend.hide();
      } else {
        this.noDataLabel.hide();
        this.chart.seriesContainer.show();
        this.chart.legend.show();
      }
    },
    updateMaxValueLabel() {
      if (!this.pieSeries || !this.innerLabel) return;

      let visibleSlices = this.pieSeries.slices.values
        .filter((slice) => !slice.isHiding && slice.visible)
        .map((slice) => ({
          label: slice.dataItem.dataContext.label,
          value: slice.dataItem.values.value.value,
        }));

      if (visibleSlices.length === 0) {
        this.innerLabel.text = "";
        return;
      }

      // let total = visibleSlices.reduce((sum, item) => sum + item.value, 0);
      let topVisible = visibleSlices.sort((a, b) => b.value - a.value)[0];

      this.innerLabel.text = `${topVisible.value}\n[bold]${topVisible.label}[/]`;
    },
    updateChart(data = this.chartData) {
      // updateChart(data = this.dummyData) {
      // console.log("🔵🔵 Updating chart...", this.chart);
      // console.log("Data chart:", this.chartData);
      if (!this.chart) return;

      let mappedData = data.map((item, index) => ({
        label: item.category,
        value: item.value,
        color: this.colors[index % this.colors.length],
      }));

      // this.mappedData = mappedData;
      // setTimeout(() => {
      // }, 0);

      this.toggleNoDataLabel(mappedData);
      this.chart.data = mappedData;
      this.chart.legend.data = mappedData.filter((item) => item.value > 0);

      // let total = mappedData.reduce((sum, item) => sum + item.value, 0);
      let highest = mappedData.reduce(
        (prev, current) => (current.value > prev.value ? current : prev),
        { label: "", value: 0 }
      );

      this.innerLabel.text =
        highest.value > 0 ? `${highest.value}\n[bold]${highest.label}[/]` : "No Data";
    },
  },
};
</script>

<style>
#SumClaimMDDetailed {
  width: 100%;
  height: 600px;
  transform: translate3d(0, 0, 0);
}

#SumClaimMDDetailed g[aria-label="Chart"] + g g[aria-labelledby] {
  opacity: 0;
}

#SumClaimMDDetailed .chart-no-data {
  width: 220px;
  height: 220px;
  border-radius: 50%;
  border: 16px solid #d8d8d8;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 24px;
  font-weight: 600;
}

#SumClaimMDDetailed .chart-no-data span:first-child {
  font-size: 48px;
  font-weight: 700;
}
</style>
